import DynamicTableAppModule from './components/DynamicTableAppModule';
//import SecondExample from './components/SecondExample';

export const DynamicTable=DynamicTableAppModule;

/*export {
  SecondExample,
};*/
